import axios from '@gen2/api/axios.request';
import { config } from '@gen2/config';
import { AxiosPromise } from 'axios';

export type TGetFileUrlRequest = {
  fileId: string;
};

export type TGetFileUrlQueryParams = {
  fileId: string;
};

export type TGetFileUrlResponse = {
  data: {
    signed_url: string;
    liveform_data: 'xfdf' | 'json' | null;
  };
};

export type TGetFilePreviewUrlResponse = {
  data: {
    preview_url: string;
    target_name: string;
  };
};

export type TGetFileDownloadUrlResponse = {
  data: {
    download_url: string;
    target_name: string;
  };
};

export type TGetDownloadUrlRequest = {
  fileId: string;
};

export const getFileUrl = ({
  fileId,
}: TGetFileUrlQueryParams): AxiosPromise<TGetFileUrlResponse> => {
  return axios.request({
    url: `${config.apiVersion.v1}/files/${fileId}/signed-url`,
    method: 'get',
    headers: {
      Accept: 'application/json',
    },
  });
};

export const getPreviewUrl = ({
  fileId,
}: TGetFileUrlQueryParams): AxiosPromise<TGetFilePreviewUrlResponse> => {
  return axios.request({
    url: `${config.apiVersion.v1}/files/${fileId}/preview-url`,
    method: 'get',
    headers: {
      Accept: 'application/json',
    },
  });
};

export const getDownloadUrl = ({
  fileId,
}: TGetDownloadUrlRequest): AxiosPromise<TGetFileDownloadUrlResponse> => {
  return axios.request({
    url: `${config.apiVersion.v1}/files/${fileId}/download-url`,
    method: 'get',
    headers: {
      Accept: 'application/json',
    },
  });
};

export type TFileUploadRequest = {
  type: string;
  typeId: string;
  file: File;
  contactId?: string;
};

// single file upload
export const uploadFile = ({
  type,
  typeId,
  file,
  contactId,
}: TFileUploadRequest): AxiosPromise<unknown> => {
  const formData = new FormData();
  formData.append('file', file);

  if (contactId) {
    formData.append('contact', contactId);
  }

  return axios.request({
    url: `${config.apiVersion.v1}/files/${type}/${typeId}`,
    data: formData,
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
};

export type DeleteFilesRequest = {
  type: string;
  typeId: string;
  files: Array<{
    id: string;
  }>;
};

export const deleteFiles = ({
  type,
  typeId,
  files,
}: DeleteFilesRequest): AxiosPromise<unknown> => {
  return axios.request({
    url: `${config.apiVersion.v1}/files/${type}/${typeId}`,
    method: 'delete',
    data: {
      files: files,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};
